import type { SpotResultsTileDesktopAttributes } from '@/features/spot-results/spot-results-desktop-v4/spot-results-desktop-v4-type';

import React from 'react';

import SpotResultDesktop from '@/features/spot-results/spot-result-desktop/spot-result-desktop';
import SpotResultsHorizontalDesktop from '@/features/spot-results/spot-result-desktop/spot-results-horizontal-desktop';
import SpotResultsInfoBoxDesktop from '@/features/spot-results/spot-results-desktop-v4/spot-results-info-box-desktop/spot-results-info-box-desktop';
import SpotResultsInfoTextDesktop from '@/features/spot-results/spot-results-desktop-v4/spot-results-info-text-desktop/spot-results-info-text-desktop';

export default function SpotResultsTileSwitchDesktop(props: SpotResultsTileDesktopAttributes) {
    switch (props.type) {
        case 'spotResult':
            return <SpotResultDesktop {...props} />;
        case 'spotResultHorizontal':
            return <SpotResultsHorizontalDesktop {...props} />;
        case 'infoBox':
            return <SpotResultsInfoBoxDesktop {...props} />;
        case 'infoText':
            return <SpotResultsInfoTextDesktop {...props} />;
    }
}
